// extracted by mini-css-extract-plugin
export default {"modal__bg":"modal_modal__bg__lAuEn","modal__bg__open":"modal_modal__bg__open__71B80","modal__title":"modal_modal__title__p7juH","modal":"modal_modal__jkVFq"};